export const TABS = {
  GAMES: "games",
  LIVE: "live",
  SOCIAL_FEED: "social_feed",
  SOCIAL_SEND: "social_send",
  SOCIAL: "social",
  LIGHT_SHOW: "light_show",
  QUOTE_SEND: "quote_send",
  LIVE_SEND: "live_send",
};

export const ONLINE_PRESENCE_INTERVAL = 2000;

export const LIBRARIES = ["places"]
